import { makeStyles } from '@material-ui/core/styles'
import { theme } from 'config/constants/theme/theme'

export const useStyles = makeStyles({
  container: {
    width: 850,
    cursor: 'default !important',
    [theme.breakpoints.down('md')]: {
      width: 'calc(100vw - 25px)'
    }
  }
})
